import { derived, writable } from 'svelte/store';
const useBookStore = () => {
    const { subscribe, set, update } = writable([]);
    const reset = () => set([]);
    const add = (newBooks) => update((books) => {
        // NOTE: Must always replace the variable directly to make the array value reactive.
        return [...books, ...newBooks];
    });
    return {
        subscribe,
        reset,
        add
    };
};
export const books = useBookStore();
/** getters */
export const find = (id) => {
    return derived(books, $books => $books.find(book => book.id === id));
};
